var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"studentList"},[_c('a-table',{attrs:{"dataSource":_vm.dataSource,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }